// This doesn't support scientific notation, but I don't really see that as an issue for our usecases
export const isNumeric = x => /^-?\d*(\.\d*)?$/.test(x);
export const isNotNumeric = x => !isNumeric(x);
